import React, { useEffect, useRef, useState } from 'react';
import { Button, Card, CardContent, Divider, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { FuseAnimate, FuseSplashScreen } from '@fuse';
import clsx from 'clsx';
import Formsy from 'formsy-react';
import { useDispatch, useSelector } from 'react-redux';
import withReducer from 'app/store/withReducer';
import * as Actions from './store/actions';
import reducer from './store/reducers';
import Error from 'app/fuse-layouts/shared-components/Error';
import * as ActionsDialog from 'app/store/actions';
import * as ActionsConfig from 'app/store/actions';


const useStyles = makeStyles(() => ({
	root: {
		backgroundImage: 'url("assets/images/backgrounds/dark-material-bg.jpg")'
	}
}));

const LicenseKey = props => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const formRef = useRef(null);

	const error = useSelector(({ licenseKey }) => licenseKey.key.error);
	const valid = useSelector(({ licenseKey }) => licenseKey.key.valid);
	const loading = useSelector(({ licenseKey }) => licenseKey.key.loading);

	const [networkError, setNetworkError] = useState(false);

	useEffect(() => {
		if (!valid) {
			dispatch(ActionsConfig.getConfig());
			dispatch(Actions.checkKey());
		}
	}, [dispatch, valid]);

	useEffect(() => {
		if (error) {
			const { type, message } = error;
			if (message === 'Network Error') {
				setNetworkError(true);
			} else {
				setNetworkError(false);
			}
			if (formRef.current && type === 'form') {
				const license = { license: 'Invalid License' };
				formRef.current.updateInputsWithError({
					...license
				});
			} else if (type === 'modal' && message) {
				dispatch(
					ActionsDialog.openDialog({
						children: <Error message={`${message}...`} clearError={() => dispatch(Actions.clearError())} />,
						maxWidth: 'xs',
						fullWidth: true,
						onClose: (event, reason) => {
							if (reason !== 'backdropClick') {
								dispatch(ActionsDialog.closeDialog());
							}
						}
					})
				);
			}
		}
	}, [dispatch, error]);

	const tryagain = () => window.location.reload();

	const ErrorModal = message => (
		<div className={clsx(classes.root, 'flex flex-col flex-auto flex-shrink-0 items-center justify-center p-32')}>
			<div className="flex flex-col items-center justify-center w-full">
				<FuseAnimate animation="transition.expandIn">
					<Card className="w-full max-w-md h-md">
						<CardContent className="flex flex-col items-center justify-center p-32 text-center">
							<img className="w-128 m-32" src="assets/images/logos/heidi_white_simple_logo.png" alt="logo" />
							<Typography variant="h3" className="mb-16">
								Something went wrong, if the problem persists please contact support.
							</Typography>
							<Divider className="w-sm" />
							<Typography style={{ color: 'red' }} variant="h4" className="mt-16">
								{message}
							</Typography>
							{networkError && (
								<>
									<Typography className="mt-16 text-lg font-medium -mb-4">
										Possible solutions:
									</Typography>
									<Typography style={{ color: 'gray', textAlign: 'left' }} className="mt-4 text-lg">
										<ul style={{ paddingLeft: '1.5rem' }}>
											<li>Check your internet connection.</li>
											<li>Ensure the server is reachable.</li>
											<li>Try clearing your cache and cookies.</li>
										</ul>
									</Typography>
								</>
							)}
							<Formsy
								onValidSubmit={tryagain}
								name="license-key-form"
								className="flex flex-col mt-48 justify-center w-full"
							>
								<Button
									id="license_key_submit-btn"
									variant="contained"
									color="primary"
									className="w-224 mx-auto my-16"
									aria-label="Subscribe"
									type="submit"
								>
									Try again
								</Button>
							</Formsy>
						</CardContent>
					</Card>
				</FuseAnimate>
			</div>
		</div>
	);
	return (
		<React.Fragment>
			{!networkError && !valid && !loading && ErrorModal('The license is invalid, please request the administrator to update it.')}
			{loading && <FuseSplashScreen />}
			{networkError && !loading && ErrorModal(`${error.toString()}`)}
			{valid && !error && <React.Fragment children={props.children} />}
		</React.Fragment>
	);
};

export default withReducer('licenseKey', reducer)(LicenseKey);
